// extracted by mini-css-extract-plugin
export default {"stepFormHeading":"stepFormHeading--mPfRD","bottomSpacer":"bottomSpacer--t9yJs"};